module.exports = __webpack_public_path__ + "img/pinterest_color.81f3e3e0.png";